import { render, staticRenderFns } from "./StockLayer.vue?vue&type=template&id=5460dd3c&scoped=true"
import script from "./StockLayer.vue?vue&type=script&lang=js"
export * from "./StockLayer.vue?vue&type=script&lang=js"
import style0 from "./StockLayer.vue?vue&type=style&index=0&id=5460dd3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5460dd3c",
  null
  
)

export default component.exports